export default function({ dispatch, commit }, data) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/auth/reset',
        data
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        //commit('initiatedReset', response)
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
